export default function SectionTitle({
  title = ['section title', 'not provided'],
  href = '#/',
}) {
  const [firstHalf, secondHalf] = title

  return (
    <div className="mb-2">
      <span className="text-dark-200 dark:text-light-300 font-roobert font-semibold text-[18px]">
        {firstHalf && (
          <>
            <a
              href={href}
              className="text-purple-400 dark:text-purple-200 hover:underline"
            >
              {firstHalf}
            </a>{' '}
          </>
        )}
        {secondHalf}
      </span>
    </div>
  )
}
